import React from 'react';
import Navbar from '../components/Navbar';
import LogoSplash from '../components/LogoSplash';
import HeroSection from '../components/HeroSection';
import ServicesPreview from '../components/ServicesPreview';
import AboutSection from '../components/AboutSection';
import AnimatedStats from '../components/AnimatedStats';
import FeaturedStoriesHome from '../components/FeaturedStoriesHome';
import WhyChooseSection from '../components/WhyChooseSection';
import TestimonialsSection from '../components/TestimonialsSection';
import Footer from '../components/Footer';

const HomePage = () => (
  <div className="bg-[#050914] min-h-screen">
    <Navbar />
    <LogoSplash />
    <HeroSection />
    <ServicesPreview />
    <AboutSection />
    <AnimatedStats />
    <FeaturedStoriesHome />
    <WhyChooseSection />
    <TestimonialsSection />
    <Footer />
  </div>
);

export default HomePage;
